import React from 'react';
import {
  TrophyOutlined,
  CrownOutlined,
  CrownFilled,
  StarOutlined,
  ThunderboltOutlined,
  FireOutlined,
} from '@ant-design/icons';

// ランクシステム定義（backend/app/services/gamification.pyと同期）
// 機能解放はプランベースに移行済み。ランク報酬はボーナスクレジット・割引・紹介/ファクトチェック解放のみ。
export const RANK_SYSTEM = [
  {
    rank: 'white_1',
    min_exp: 0,
    display_name: 'ホワイト I',
    color: '#8c8c8c',
    icon: 'TrophyOutlined',
    rewards: [],
  },
  {
    rank: 'white_2',
    min_exp: 5,
    display_name: 'ホワイト II',
    color: '#8c8c8c',
    icon: 'TrophyOutlined',
    rewards: [{ type: 'bonus_credit', amount: 40 }],
  },
  {
    rank: 'white_3',
    min_exp: 8,
    display_name: 'ホワイト III',
    color: '#8c8c8c',
    icon: 'TrophyOutlined',
    rewards: [{ type: 'bonus_credit', amount: 60 }],
  },
  {
    rank: 'white_4',
    min_exp: 13,
    display_name: 'ホワイト IV',
    color: '#8c8c8c',
    icon: 'TrophyOutlined',
    rewards: [{ type: 'bonus_credit', amount: 40 }],
  },

  {
    rank: 'bronze_1',
    min_exp: 25,
    display_name: 'ブロンズ I',
    color: '#CD7F32',
    icon: 'TrophyOutlined',
    rewards: [{ type: 'bonus_credit', amount: 30 }],
  },
  {
    rank: 'bronze_2',
    min_exp: 35,
    display_name: 'ブロンズ II',
    color: '#CD7F32',
    icon: 'TrophyOutlined',
    rewards: [{ type: 'bonus_credit', amount: 30 }],
  },
  {
    rank: 'bronze_3',
    min_exp: 50,
    display_name: 'ブロンズ III',
    color: '#CD7F32',
    icon: 'TrophyOutlined',
    rewards: [
      { type: 'bonus_credit', amount: 25 },
      {
        type: 'feature_unlock',
        feature: 'referral_system',
        description: '紹介システム',
      },
    ],
  },

  {
    rank: 'silver_1',
    min_exp: 70,
    display_name: 'シルバー I',
    color: '#A8A8A8',
    icon: 'CrownOutlined',
    rewards: [{ type: 'bonus_credit', amount: 30 }],
  },
  {
    rank: 'silver_2',
    min_exp: 95,
    display_name: 'シルバー II',
    color: '#A8A8A8',
    icon: 'CrownOutlined',
    rewards: [{ type: 'bonus_credit', amount: 50 }],
  },
  {
    rank: 'silver_3',
    min_exp: 125,
    display_name: 'シルバー III',
    color: '#A8A8A8',
    icon: 'CrownOutlined',
    rewards: [{ type: 'bonus_credit', amount: 60 }],
  },

  {
    rank: 'gold_1',
    min_exp: 160,
    display_name: 'ゴールド I',
    color: '#DAA520',
    icon: 'StarOutlined',
    rewards: [{ type: 'bonus_credit', amount: 70 }],
  },
  {
    rank: 'gold_2',
    min_exp: 200,
    display_name: 'ゴールド II',
    color: '#DAA520',
    icon: 'StarOutlined',
    rewards: [{ type: 'bonus_credit', amount: 90 }],
  },
  {
    rank: 'gold_3',
    min_exp: 250,
    display_name: 'ゴールド III',
    color: '#DAA520',
    icon: 'StarOutlined',
    rewards: [{ type: 'bonus_credit', amount: 110 }],
  },

  {
    rank: 'platinum_1',
    min_exp: 310,
    display_name: 'プラチナ I',
    color: '#B0B0B0',
    icon: 'StarOutlined',
    rewards: [
      { type: 'bonus_credit', amount: 130 },
      {
        type: 'permanent_discount',
        rate: 0.1,
        description: '全プラン 10%割引',
      },
    ],
  },
  {
    rank: 'platinum_2',
    min_exp: 380,
    display_name: 'プラチナ II',
    color: '#B0B0B0',
    icon: 'StarOutlined',
    rewards: [{ type: 'bonus_credit', amount: 160 }],
  },
  {
    rank: 'platinum_3',
    min_exp: 460,
    display_name: 'プラチナ III',
    color: '#B0B0B0',
    icon: 'StarOutlined',
    rewards: [{ type: 'bonus_credit', amount: 190 }],
  },

  {
    rank: 'diamond_1',
    min_exp: 560,
    display_name: 'ダイヤモンド I',
    color: '#4FC3F7',
    icon: 'FireOutlined',
    rewards: [
      { type: 'bonus_credit', amount: 230 },
      {
        type: 'permanent_discount',
        rate: 0.15,
        description: '全プラン 15%割引',
      },
    ],
  },
  {
    rank: 'diamond_2',
    min_exp: 700,
    display_name: 'ダイヤモンド II',
    color: '#4FC3F7',
    icon: 'FireOutlined',
    rewards: [{ type: 'bonus_credit', amount: 270 }],
  },
  {
    rank: 'diamond_3',
    min_exp: 880,
    display_name: 'ダイヤモンド III',
    color: '#4FC3F7',
    icon: 'FireOutlined',
    rewards: [{ type: 'bonus_credit', amount: 320 }],
  },

  {
    rank: 'legend',
    min_exp: 1200,
    display_name: 'レジェンド',
    color: '#FF4757',
    icon: 'CrownFilled',
    rewards: [
      { type: 'bonus_credit', amount: 500 },
      {
        type: 'feature_unlock',
        feature: 'fact_check_mode',
        description: '???',
      },
      {
        type: 'permanent_discount',
        rate: 0.2,
        description: '全プラン 20%割引',
      },
    ],
  },
];

// アイコンマッピング
const ICON_MAP = {
  TrophyOutlined: TrophyOutlined,
  CrownOutlined: CrownOutlined,
  CrownFilled: CrownFilled,
  StarOutlined: StarOutlined,
  ThunderboltOutlined: ThunderboltOutlined,
  FireOutlined: FireOutlined,
};

/**
 * ランクアイコン表示コンポーネント
 */
export const RankIcon = ({ rank, size = 20, showName = false, style = {} }) => {
  const rankData = RANK_SYSTEM.find(r => r.rank === rank) || RANK_SYSTEM[0];
  const IconComponent = ICON_MAP[rankData.icon] || TrophyOutlined;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        ...style,
      }}
    >
      <IconComponent
        style={{
          fontSize: size,
          color: rankData.color,
        }}
      />
      {showName && (
        <span
          style={{
            fontSize: size * 0.7,
            fontWeight: 600,
            color: rankData.color,
          }}
        >
          {rankData.display_name}
        </span>
      )}
    </span>
  );
};

/**
 * EXPから現在のランクと次のランクを取得
 */
export const getRankByExp = exp => {
  let currentRank = RANK_SYSTEM[0];
  let nextRank = RANK_SYSTEM[1];

  for (let i = RANK_SYSTEM.length - 1; i >= 0; i--) {
    if (exp >= RANK_SYSTEM[i].min_exp) {
      currentRank = RANK_SYSTEM[i];
      nextRank = RANK_SYSTEM[i + 1] || null;
      break;
    }
  }

  return { currentRank, nextRank };
};

/**
 * ランクIDから表示名を取得
 */
export const getRankDisplayName = rankId => {
  const rankData = RANK_SYSTEM.find(r => r.rank === rankId);
  return rankData ? rankData.display_name : rankId;
};

/**
 * EXP進捗バー表示コンポーネント
 */
export const ExpProgress = ({
  totalExp,
  showNumbers = true,
  size = 'default', // 'small' | 'default' | 'large'
  style = {},
}) => {
  const { currentRank, nextRank } = getRankByExp(totalExp);

  if (!nextRank) {
    // 最高ランク到達
    return (
      <div style={{ width: '100%', ...style }}>
        <style>{`
          @keyframes move-bg-exp {
            to {
              background-position: 300% 0;
            }
          }
        `}</style>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: size === 'small' ? 4 : 8,
          }}
        >
          <span
            style={{
              fontSize: size === 'small' ? 12 : size === 'large' ? 16 : 14,
              fontWeight: 600,
              color: currentRank.color,
            }}
          >
            {currentRank.display_name}
          </span>
          {showNumbers && (
            <span
              style={{
                fontSize: size === 'small' ? 11 : size === 'large' ? 14 : 12,
                color: '#8c8c8c',
              }}
            >
              {totalExp} EXP (最高ランク)
            </span>
          )}
        </div>
        <div
          style={{
            width: '100%',
            height: size === 'small' ? 6 : size === 'large' ? 10 : 8,
            background: '#f0f0f0',
            borderRadius: 4,
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              width: '100%',
              height: '100%',
              background:
                'linear-gradient(90deg, #0072ff, #00d4ff, #2aebca, #925ee6, #0072ff) 0 0 / 300% 100%',
              animation: 'move-bg-exp 10s linear infinite',
              borderRadius: 4,
            }}
          />
        </div>
      </div>
    );
  }

  const expInCurrentRank = totalExp - currentRank.min_exp;
  const expNeededForNext = nextRank.min_exp - currentRank.min_exp;
  const progress = Math.min((expInCurrentRank / expNeededForNext) * 100, 100);

  return (
    <div style={{ width: '100%', ...style }}>
      <style>{`
        @keyframes move-bg-exp {
          to {
            background-position: 300% 0;
          }
        }
      `}</style>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: size === 'small' ? 4 : 8,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span
            style={{
              fontSize: size === 'small' ? 12 : size === 'large' ? 16 : 14,
              fontWeight: 600,
              color: currentRank.color,
            }}
          >
            {currentRank.display_name}
          </span>
          <span
            style={{
              fontSize: size === 'small' ? 11 : size === 'large' ? 13 : 12,
              color: '#8c8c8c',
            }}
          >
            → {nextRank.display_name}
          </span>
        </div>
        {showNumbers && (
          <span
            style={{
              fontSize: size === 'small' ? 11 : size === 'large' ? 14 : 12,
              color: '#8c8c8c',
            }}
          >
            {expInCurrentRank} / {expNeededForNext} EXP
          </span>
        )}
      </div>
      <div
        style={{
          width: '100%',
          height: size === 'small' ? 6 : size === 'large' ? 10 : 8,
          background: '#f0f0f0',
          borderRadius: 4,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <div
          style={{
            width: `${progress}%`,
            height: '100%',
            background:
              'linear-gradient(90deg, #0072ff, #00d4ff, #2aebca, #925ee6, #0072ff) 0 0 / 300% 100%',
            animation: 'move-bg-exp 10s linear infinite',
            transition: 'width 0.6s ease-out',
            borderRadius: 4,
          }}
        />
      </div>
    </div>
  );
};

export default { RankIcon, ExpProgress, RANK_SYSTEM, getRankByExp };
